import ComplaintContent from './ComplaintContent.jsx';

export {ComplaintContent}



// WEBPACK FOOTER //
// ./components/users/sub-view/complaint-content/index.js